import { SET_ENTITY_MANAGER_FORMS } from '@state-management/constants';
import { Action } from '../actions';

export interface EntityFormsReducerState {
  forms_list: unknown[];
}

const initialState: EntityFormsReducerState = {
  forms_list: [],
};

export function EMFormsReducer(state = initialState, action: Action): EntityFormsReducerState {
  switch (action.type) {
    case SET_ENTITY_MANAGER_FORMS: {
      const data = action.payload?.data;
      return { ...state, forms_list: data ?? [] };
    }
    default: {
      return state;
    }
  }
}

export const getEntityManagerFormsList = (state: EntityFormsReducerState) => state.forms_list;
